import React from 'react';
import styled from 'styled-components';

import { SearcherEmpty } from '@lt/components';
import HotelRoomCardSkeleton from './HotelRoomCardSkeleton';
import HotelRooms, { IHotelRooms } from './HotelRooms';

import { SEARCH_TYPE_NAMES } from '../../../components/Cigarette/constants';

import type { SearchType } from '@lt/api/dist/types/searchParams';

interface IHotelSearchResults extends IHotelRooms {
  displayedHotelRoomsCount: number;
  searchType: SearchType;
  isInitial: boolean;
}

const HotelSearchResults = (props: IHotelSearchResults): JSX.Element => {
  const { searchType, displayedHotelRoomsCount, isMobile, isInitial } = props;

  const hotelRoomsData = props.hotelRoomsData
    // .filter(
    //   (hotelRoom) =>
    //     hotelRoom.meal_types.filter((mealType) => mealType.id == selectedMealType).length > 0
    // )
    .slice(0, displayedHotelRoomsCount);

  if (hotelRoomsData.length) {
    return <HotelRooms {...{ ...props, hotelRoomsData }} />;
  }

  if (!isInitial) {
    return (
      <HotelSearchResultsContainer $isMobile={isMobile} $isCentered>
        <SearcherEmpty isHotelOnly={searchType === SEARCH_TYPE_NAMES.HOTEL} />
      </HotelSearchResultsContainer>
    );
  }

  return (
    <HotelSearchResultsContainer $isMobile={isMobile}>
      {[...Array(displayedHotelRoomsCount).keys()].map((i) => (
        <HotelRoomCardSkeleton key={i} />
      ))}
    </HotelSearchResultsContainer>
  );
};

export const HotelSearchResultsContainer = styled.div<{
  $isMobile: boolean;
  $isCentered?: boolean;
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  padding-left: 8px;

  ${({ $isCentered }) => $isCentered && 'justify-content: center;'}

  ${({ $isMobile }) =>
    $isMobile
      ? `
    & > * {
      flex-basis: 100%;
    };
    `
      : ''}
`;

export default HotelSearchResults;
